var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useFileSize } from "@/atoms/cacheFileSize";
import { formatFileSize } from "@/utils/fileSize";
import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./FileDownloadLink.module.scss";
import { IconTheme, TextIconButton } from "./IconButton/IconButton";
import classNames from "classnames";
export function FileDownloadLink(_a) {
    var _b;
    var url = _a.url, props = __rest(_a, ["url"]);
    var intl = useIntl();
    var size = useFileSize(url);
    var formattedSize = useMemo(function () { return formatFileSize(size); }, [size]);
    var displayedUnit = useMemo(function () {
        if (formattedSize.unit === "b")
            return intl.formatMessage({ defaultMessage: "B", id: "hIsHef" });
        if (formattedSize.unit === "kb")
            return intl.formatMessage({ defaultMessage: "KB", id: "vDIBFm" });
        if (formattedSize.unit === "mb")
            return intl.formatMessage({ defaultMessage: "MB", id: "6pLkvd" });
        if (formattedSize.unit === "gb")
            return intl.formatMessage({ defaultMessage: "GB", id: "LRu6Sn" });
        if (formattedSize.unit === "tb")
            return intl.formatMessage({ defaultMessage: "TB", id: "i7AtQr" });
    }, [intl, formattedSize]);
    return (React.createElement(TextIconButton, { href: url, download: true, className: styles.downloadButton, theme: IconTheme.Blue, onClick: props.onClick, target: "_blank" },
        React.createElement("span", { className: classNames(styles.content, (_b = {},
                _b[styles.centered] = props.content === "artbook" && props.recommended,
                _b)) },
            React.createElement("span", { className: styles.title },
                props.content === "artbook" && (React.createElement(React.Fragment, null,
                    props.quality === "ld" && (React.createElement(FormattedMessage, { defaultMessage: "Artbook LD", id: "BF3Zws" })),
                    props.quality === "hd" && (React.createElement(FormattedMessage, { defaultMessage: "Artbook HD", id: "rEpjhB" })),
                    props.quality === "4k" && (React.createElement(FormattedMessage, { defaultMessage: "Artbook 4K", id: "q/zfYB" })),
                    props.quality == null && (React.createElement(FormattedMessage, { defaultMessage: "Artbook", id: "Wa38YV" })))),
                props.content === "soundtrack" && (React.createElement(FormattedMessage, { defaultMessage: "Soundtrack", id: "lNXgr4" }))),
            React.createElement("span", { className: styles.info },
                size > 0 && (React.createElement("span", null,
                    "(",
                    props.content === "artbook" ? ".pdf" : ".mp3",
                    " - ", "".concat(formattedSize.value).concat(displayedUnit),
                    ")")),
                props.content === "artbook" && props.recommended && (React.createElement(FormattedMessage, { defaultMessage: "> Recommended", id: "5Qzt9O", tagName: "span" })))),
        React.createElement("img", { src: require("@/public_assets/icon_download_white.png"), style: { height: "25px" } })));
}
